import { Box, StatCard } from 'ui';
import { Check, WarningAmber } from 'ui/icons';

export const EvidenceSessionStats = ({ failed, passed }: { failed: number; passed: number }) => {
  return (
    <Box display="flex" flexWrap="wrap" gap={1} data-testid="evidence-session-stats">
      <StatCard
        icon={<Check color="success" />}
        title="Included"
        value={passed}
        subtitle="Images passed our requirement rules"
      />
      <StatCard
        icon={<WarningAmber color="warning" />}
        title="Excluded"
        value={failed}
        subtitle="Images failed our requirement rules"
      />
    </Box>
  );
};
